module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-27.888f7148.svg";